import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20lifestyle%20composition%20with%20sneakers%20handbags%20clothing%20and%20accessories%20beautifully%20arranged%20on%20warm%20cream%20surface%2C%20soft%20diffused%20natural%20light%2C%20editorial%20high%20end%20product%20photography%2C%20minimal%20Scandinavian%20aesthetic%2C%20clean%20and%20airy%20feel%2C%20gentle%20textures%2C%20high%20detail%2C%20organic%20arrangement%2C%20aspirational%20shopping%20mood%2C%20sophisticated%20retail%20concept&width=1600&height=700&seq=kakobuy-cta-v3-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet - rozpocznij zakupy"
          title="Kakobuy Spreadsheet - kup teraz"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          Gotowy, aby znaleźć najlepsze okazje?
        </h2>
        <p className="text-base text-white/80 max-w-xl mx-auto mb-10 leading-relaxed">
          Dołącz do tysięcy zadowolonych użytkowników Kakobuy Spreadsheet.
          Oszczędzaj czas i pieniądze dzięki naszej bazie produktów.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-foreground-950 font-label font-semibold text-sm hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-cart-2-line"></i>
            Kakobuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-label font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-flashlight-line"></i>
            Buy It Now
          </a>
          <Link
            to="/artykul/kakobuy-spreadsheet-polska-poradnik"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-white/30 text-white font-label font-semibold text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-book-open-line"></i>
            Przeczytaj poradnik
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { num: '1200+', label: 'Produktów' },
            { num: '50+', label: 'Kategorii' },
            { num: 'Codzienna', label: 'Aktualizacja' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-300">{stat.num}</div>
              <div className="text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}